import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ShoppingBagIcon, ShoppingCartIcon } from '@heroicons/react/24/outline';
import OrdersTab from '../components/orders/OrdersTab';
import CartsTab from '../components/orders/CartsTab';
import { Toast } from '../components/orders/ui';

const TABS = [
  { key: 'orders', label: 'Заказы', Icon: ShoppingBagIcon },
  { key: 'carts', label: 'Корзины', Icon: ShoppingCartIcon },
];

/** Все заказы и корзины приложения: просмотр и ручное управление. Вкладка — в ?tab=. */
const OrdersManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') === 'carts' ? 'carts' : 'orders';
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);

  const notify = useCallback((type, text) => setToast({ type, text }), []);

  useEffect(() => {
    if (!toast || toast.type === 'error') return undefined;
    const t = setTimeout(() => setToast(null), 3500);
    return () => clearTimeout(t);
  }, [toast]);

  // Профиль пользователя (там же смена тарифа) — страница «Пользователи» с ?id=
  const openUser = useCallback((userId) => navigate(`/users?id=${userId}`), [navigate]);

  return (
    <div className="space-y-4 text-left">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="text-2xl font-bold text-text-primary">Заказы и корзины</h2>
          <p className="mt-0.5 text-sm text-text-secondary">Все заказы и корзины пользователей приложения</p>
        </div>
        <div className="inline-flex rounded-lg border border-border-primary bg-bg-card p-1">
          {TABS.map(({ key, label, Icon }) => (
            <button
              key={key}
              type="button"
              onClick={() => {
                setToast(null);
                setSearchParams(key === 'orders' ? {} : { tab: key });
              }}
              className={`inline-flex items-center gap-2 rounded-md px-4 py-1.5 text-sm font-medium ${
                tab === key ? 'bg-accent-grad text-white' : 'text-text-secondary hover:bg-bg-tertiary'
              }`}
            >
              <Icon className="h-4 w-4" />
              {label}
            </button>
          ))}
        </div>
      </div>

      <Toast toast={toast} onClose={() => setToast(null)} />

      {tab === 'orders' ? <OrdersTab notify={notify} onOpenUser={openUser} /> : <CartsTab notify={notify} onOpenUser={openUser} />}
    </div>
  );
};

export default OrdersManagement;
